import React from "react";
import {Container} from "react-bootstrap";
import PurposeBox from "../../Components/SalesAnalysis/PurposeBox.jsx";
import StammdatenRepsTable from "../../Components/SalesAnalysis/StammdatenRepsTable.jsx";
import useAnalysisMeta from "../../Components/SalesAnalysis/useAnalysisMeta.js";

/**
 * Stammdatenseite der Vertriebsauswertung - hier zunächst nur der
 * Mindestteil aus AP6 (Vertreterkürzel ↔ Benutzer). Ausschlusslisten,
 * Länder, nicht zugeordnete Artikel und Nummernkonflikte folgen mit AP13.
 */
export default function SalesAnalysisStammdaten() {
    const {meta, metaError} = useAnalysisMeta();

    return (
        <Container fluid className="pt-2 pb-4">
            <PurposeBox />
            <h1 className="h4 mb-2">Stammdaten</h1>
            {metaError && <div className="alert alert-warning">{metaError}</div>}
            <StammdatenRepsTable meta={meta} />
        </Container>
    );
}
